// src/mocks/handlers/orders.handlers.js
import * as data from '../data/orders.demo';

export const handle = async (config) => {
    if (config.method === 'post') return { success: true, data: data.orderDetail };
    if (config.method === 'put') return { success: true };
    if (config.method === 'delete') return { success: true };
    if (/\/orders\/\d+$/.test(config.url)) return { success: true, data: data.orderDetail };
    return { success: true, data: data.orderList };
};

export const create = async () => ({ success: true, data: data.orderDetail });
export const updateStatus = async () => ({ success: true });
export const cancel = async () => ({ success: true });
export const getItems = async () => ({ success: true, data: data.orderItems });
export const getBySupplier = async () => ({ success: true, data: data.orderList });
export const getAttachments = async () => ({ success: true, attachments: [] });
export const searchProductsBySupplier = async () => data.productSearchResults;
export const checkDuplicates = async () => ({ hasDuplicates: false, duplicates: [] });
